import { Preloader } from "../Common/Preloader";

export const checkoutVerification = {

    clientSecret: null,
    stripe: null,
    bankAccount: null,
    returnScript: null,
    checkSignatureCb:null,
    orgStripeId:null,

    setReturnScript(returnScript=null) {
        this.returnScript = returnScript;
    },

    setCheckSignatureCb(cb=null){
        this.checkSignatureCb = cb
    },

    startCheckoutVerification(bankAccount, options = null) {
        if(typeof this.checkSignatureCb == 'function'){
            const signature = this.checkSignatureCb()
            if(signature)
                options = typeof options === 'object' ? {...options, signature} : {signature}
            else
                return
        }
        this.bankAccount = bankAccount;
        let data = options;
        $.ajax({
            method:'POST',
            url: `${this.bankAccount.urlRoot}/${this.bankAccount.id}/verify/checkout`,
            data: data,
            async: false,
            success: (response) => this.checkoutVerification(response)
        });
        this.checkoutListners();
    },

    checkoutVerification(response) {
        let message;
        const key = $('meta[name=stripe-pk]').attr('content');
        this.orgStripeId = $('meta[name=org-stripe-id]').attr('content') ?? null;
        const addOpts = this.orgStripeId ? {stripeAccount:this.orgStripeId} : []; 
        this.stripe = new Stripe(key, addOpts);
        this.clientSecret = response.stripe_secret;
        this.stripe.collectBankAccountForPayment({
            clientSecret: this.clientSecret,
            params: {
                payment_method_type: 'us_bank_account',
                payment_method_data: {
                    billing_details: {
                        name: response.customer.name,
                        email: response.customer.email,
                    },
                },
            },
            expand: ['payment_method'],
        })
        .then(({paymentIntent, error}) => {
            // console.log(paymentIntent)
            // console.log(this.bankAccount)
            if (error) {
                message = 'Something went wrong and verification failed. Try again. if you see this message again while verifying this account, you might need to use <strong>Manual Verification</strong> Instead.';
                this.nextMessage(this.bankAccount, 'failed', message);
            }else if(paymentIntent.status === 'requires_payment_method'){
                message = 'Bank connection was not completed. Your account was not charged. You can try instant verification again or use <strong>Manual Verification</strong>.';
                this.nextMessage(this.bankAccount, 'failed', message);
            } else if (paymentIntent.status === 'requires_confirmation') {
                if ($('input#selected_pm').val()) {
                    this.checkoutConfirmPayment();
                }else{
                    message = `Please confirm that you allow us to process a test payment in the amount of $0.50 from your bank account in order to verify it. It will be refunded automatically.
                    <br/>Verification is instant, refund will take 4-5 business days to fully process.`;
                    // `We need your confirmation that you allow us to process a test payment in the amount of $0.50 from your bank account in order to verify it and then refund it.
                    //     <br/>Verification is instant, refund will take 4-5 business days to fully process.`;
                    this.nextMessage(this.bankAccount, 'confirmation', message);
                }
            } else {
                this.checkoutConfirmPayment();
            }
        });
    },
    nextMessage(bankAccount, status, message=null) {
        $.ajax({
            url: `${bankAccount.urlRoot}/${bankAccount.id}/verify/checkout-message`,
            data: { status, message},
            async: false,
            success: (response) => {
                $('#form-container').html(response.modal);
                $('.modal-backdrop').first().remove();
                $('#form-container .modal').modal('show');
            }
        });
    },

    checkoutConfirmPayment() {
        let message;
        this.stripe.confirmUsBankAccountPayment(this.clientSecret)
            .then(({paymentIntent, error}) => {
                if (error) {
                    this.nextMessage(this.bankAccount, 'failed');
                } else if (paymentIntent.status === "processing") {
                    this.bankAccount.patchCheckoutVerification(paymentIntent.payment_method, paymentIntent.id, this.orgStripeId)
                        .then(() => {
                            this.nextMessage(this.bankAccount, 'success');
                        })
                        .catch(() => {
                            message = 'Your bank was connected, but BizBaby could not save the verification result. Your account was not charged by BizBaby. Please try again.';
                            this.nextMessage(this.bankAccount, 'failed', message);
                        });
                } else if (paymentIntent.status === "requires_payment_method") {
                    message = 'Looks like this payment method can’t be used. Please add a different payment method. You can try using credit card instead or try verifying a different bank account.';
                    this.nextMessage(this.bankAccount, 'failed', message);
                } else if (paymentIntent.next_action?.type === "verify_with_microdeposits") {
                    message = `Looks like this payment can’t be verified via instant verification process. Please start verification once again, this time select <div class="mannually_verification-start" data-id=${this.bankAccount.id}>Manual Verification</div> option.`;
                    this.nextMessage(this.bankAccount, 'next_action', message);
                }
            });
    },

    checkoutListners() {
        $('body').off('click',  '#confirm-checkout-verification');
        $('body').on('click', '#confirm-checkout-verification', () => {
            const preloader = new Preloader('init_verification-modal', true);
            preloader.setMessage('Wait until bank is checking your data');
            preloader.open();
            this.checkoutConfirmPayment();
        });
        $('body ').off('click', '[data-post-script]');
        $('body').on('click', '[data-post-script]', () => {
            this.returnScript
        } );
    }
}
